import { Label } from "@mui/icons-material";
import { getWeekForNum } from "../../utils";
import { format } from 'date-fns';
import { get } from 'immutadot';
import * as XLSX from 'xlsx';


const panelBookingsExport = (rows:any[],startWeekNum=0) => {
    const pixPerLetter = 7;
    const worksheet = {'!ref': 'A1:'};
    const convertTypes = {
        BLANK:'Fully available',
        PARTIAL:'Partially booked',
        BOOKED:'Fully booked',
        PENCIL:'Partially booked'
    };
    const columns: any[] = [{
        label: 'Site Name', accessor: 'site.name', getRowValue: (row) => {
            return {link: row.site?.externalLink, label: row.site?.name};
        }, exportAs: 'link'
    }, 
    {label: 'Restriction', accessor: 'pack.label'},
        {label: 'Distributor', accessor: 'site.distributor.name'},
        {
            label: 'Address', accessor: 'site.address1', getRowValue: function (row) {
                return [row.site.address1 ?? '', row.site.address2 ?? '', row.site.postcode ?? ''].join(', ');
            }
        },
        {label: 'Structure', accessor: 'site.siteStructure.name'},
        {
            label: 'Num', accessor: 'panel', getValue: function (v) {
                v ?? '';
            }
        }];
    const colWidths = [];
    for(let i=0; i<5; i++) {
        columns.push({
            label:format(getWeekForNum(i+startWeekNum),'dd MM yyyy'),
            accessor:'panelBookingDatesSummary['+i+'].status',
            getValue:(v) => {return convertTypes[v]??''; }
        });
    }
    let colIdx = 0;
    columns.forEach((col)=>{
        worksheet[String.fromCharCode(64 + colIdx+1)+'1'] = {t:'s',v:col.label};
        colIdx++;
        colWidths.push({ wpx: col.label.toString().length });
    });
    let rowIdx = 1;
    rows.forEach((row)=>{

        colIdx = 0;
        columns.forEach((column)=>{
            let value = get(row, column.accessor);
            if(column.getValue) { value = column.getValue(value); }
            if(column.getRowValue) { value = column.getRowValue(row); }
            switch(column.exportAs) {
                case 'link':
                    worksheet[String.fromCharCode(64 + colIdx+1)+(rowIdx+1)] = {t:'s',v:value.label,l:{'Target':value.link}};
                    value = value.label;
                break;
                case 'text':
                default:
                    worksheet[String.fromCharCode(64 + colIdx+1)+(rowIdx+1)] = {t:'s',v:value};
                break;
            }
            colIdx++;
            if (value) {
                colWidths[colIdx - 1].wpx = Math.max(colWidths[colIdx - 1].wpx, value.toString().length);
            }
        })
        rowIdx++;
    });
    colWidths.forEach(v => { v.wpx = v.wpx * pixPerLetter; });
    worksheet['!cols'] = colWidths;
    worksheet['!ref'] = 'A1:' + String.fromCharCode(64 + columns.length)+(rows.length+1);
    const wb = XLSX.utils.book_new();
    //var cell = ws['A2'];
    //console.log(worksheets);
    //worksheet['A2'] = {t:'s',v: 'TEST'};
    XLSX.utils.book_append_sheet(wb, worksheet, "SheetJS");
    XLSX.writeFile(wb, "panels.xlsx");
    return worksheet;
}

export default panelBookingsExport;